import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { OrderBumpModal } from './OrderBumpModal';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'pro'>('pro');
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="pricing" className="w-full py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #050504 0%, #0a0908 50%, #050504 100%)'
  }} data-id="element-234">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full opacity-[0.03] pointer-events-none" style={{
      background: 'radial-gradient(circle, #C9A84C 0%, transparent 70%)'
    }} data-id="element-235" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full max-w-3xl flex flex-col items-center relative z-10" data-id="element-236">
        <div className="text-brand-gold text-[10px] font-bold tracking-[0.3em] uppercase mb-4" data-id="element-237">
          Acceso inmediato
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white text-center mb-3 tracking-tight" data-id="element-238">
          Elegí tu <span className="text-brand-gold" data-id="element-239">MegaPack</span>
        </h2>
        <p className="text-gray-500 text-sm mb-10 text-center" data-id="element-240">
          Pago único. Sin suscripciones. Tuyo para siempre.
        </p>

        <div className="w-full flex flex-col gap-3 mb-8" data-id="element-241">
          <div onClick={() => setSelectedPack('basic')} className={`w-full rounded-xl p-5 cursor-pointer transition-all duration-300 flex items-start gap-4 ${selectedPack === 'basic' ? 'border-2 border-brand-gold/50 shadow-[0_0_35px_rgba(201,168,76,0.15),0_0_15px_rgba(201,168,76,0.08)]' : 'border border-white/10 hover:border-brand-gold/25 hover:shadow-[0_0_20px_rgba(201,168,76,0.06)]'}`} style={{
          background: selectedPack === 'basic' ? 'linear-gradient(135deg, #171308 0%, #0e0d0a 100%)' : 'linear-gradient(135deg, #0e0e0e 0%, #0a0a0a 100%)'
        }} data-id="element-242">
            <div className="shrink-0 mt-1" data-id="element-243">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${selectedPack === 'basic' ? 'border-brand-gold' : 'border-gray-700'}`} data-id="element-244">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-brand-gold" data-id="element-245" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-246">
              <div className="flex flex-col" data-id="element-247">
                <h3 className="text-sm sm:text-base font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-248">
                  <span data-id="element-249">📘</span> MEGAPACK SALIR DEL VERAZ
                </h3>
                <p className="text-gray-500 text-xs" data-id="element-250">6 Tomos + 6 Bonos</p>
                <p className="text-brand-gold/70 text-[11px] font-medium mt-1" data-id="element-251">
                  Ideal para: Todos los casos de Veraz y BCRA
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-252">
                <span className="text-red-500 line-through text-[11px] font-semibold" data-id="element-253">
                  $39.998
                </span>
                <span className="text-xl sm:text-2xl font-extrabold text-white leading-tight" data-id="element-254">
                  $19.999
                </span>
                <span className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-255">
                  ARS
                </span>
              </div>
            </div>
          </div>

          <div onClick={() => setSelectedPack('pro')} className={`w-full rounded-xl p-5 cursor-pointer transition-all duration-300 flex items-start gap-4 relative ${selectedPack === 'pro' ? 'border-2 border-brand-gold/50 shadow-[0_0_35px_rgba(201,168,76,0.15),0_0_15px_rgba(201,168,76,0.08)]' : 'border border-white/10 hover:border-brand-gold/25 hover:shadow-[0_0_20px_rgba(201,168,76,0.06)]'}`} style={{
          background: selectedPack === 'pro' ? 'linear-gradient(135deg, #171308 0%, #0e0d0a 100%)' : 'linear-gradient(135deg, #0e0e0e 0%, #0a0a0a 100%)'
        }} data-id="element-256">
            <div className="absolute -top-2.5 right-4 bg-brand-gold text-black text-[9px] font-extrabold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-257">
              Más elegido
            </div>
            <div className="shrink-0 mt-1" data-id="element-258">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${selectedPack === 'pro' ? 'border-brand-gold' : 'border-gray-700'}`} data-id="element-259">
                {selectedPack === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand-gold" data-id="element-260" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-261">
              <div className="flex flex-col" data-id="element-262">
                <h3 className="text-sm sm:text-base font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-263">
                  <span data-id="element-264">🏆</span> MEGAPACK + RETRIBUCIÓN
                </h3>
                <p className="text-gray-500 text-xs" data-id="element-265">
                  6 Tomos + 6 Bonos + Kit Retribución completo
                </p>
                <p className="text-brand-gold/70 text-[11px] font-medium mt-1" data-id="element-266">
                  Ideal para: Quienes quieren reclamar daños y perjuicios
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-267">
                <span className="text-red-500 line-through text-[11px] font-semibold" data-id="element-268">
                  $54.998
                </span>
                <span className="text-xl sm:text-2xl font-extrabold text-brand-gold leading-tight" data-id="element-269">
                  $27.999
                </span>
                <span className="text-gray-500 text-[10px] uppercase tracking-wider" data-id="element-270">
                  ARS
                </span>
              </div>
            </div>
          </div>
        </div>

        <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="w-full font-extrabold text-base sm:text-lg py-4 px-8 rounded-xl transition-all duration-300 uppercase tracking-wide text-white bg-green-500 hover:bg-green-600 block text-center" style={{
        boxShadow: '0 0 30px rgba(34,197,94,0.3), 0 4px 15px rgba(0,0,0,0.3)'
      }} data-id="element-271">
          Quiero mi MegaPack →
        </motion.button>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-[10px] sm:text-xs text-gray-500 font-medium mt-8" data-id="element-272">
          <span className="flex items-center gap-1.5" data-id="element-273">🔒 Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-274">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1.5" data-id="element-275">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-276">
            💳 Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </motion.div>

      <OrderBumpModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} selectedPack={selectedPack} data-id="element-277" />
    </section>;
}